import type { MenuConfig } from '~typings/menu'

import permisosTributacionPg, { RESOURCE_TRIBUTACION_PG } from '@/auth/permissions/modules/tributacionPg'
import * as names from '@routes/tributacion-pg/nombres/configuracion'

const { configuracion } = permisosTributacionPg
export default [
    {
        title: 'tributacion.subopciones.transaccion_tributaria',
        route: names.ROUTE_TRANSACCION_TRIBUTARIA,
        resource: RESOURCE_TRIBUTACION_PG,
        action: configuracion.transaccionTributaria,
    },
    {
        title: 'tributacion.subopciones.comprobantes_autorizados',
        route: names.ROUTE_COMPROBANTE_AUTORIZADO,
        resource: RESOURCE_TRIBUTACION_PG,
        action: configuracion.comprobanteAutorizado,
    },
    {
        title: 'tributacion.subopciones.conceptos_retencion_fuente',
        route: names.ROUTE_CONCEPTOS_RETENCION_FUENTE,
        resource: RESOURCE_TRIBUTACION_PG,
        action: configuracion.conceptosRetencionFuente,
    },
    {
        title: 'tributacion.subopciones.campos_formulario_103',
        route: names.ROUTE_CAMPOS_FORMULARIO_103,
        resource: RESOURCE_TRIBUTACION_PG,
        action: configuracion.camposFormulario103,
    },
    {
        title: 'tributacion.subopciones.parametros_rdep',
        route: names.ROUTE_PARAMETROS_RDEP,
        resource: RESOURCE_TRIBUTACION_PG,
        action: configuracion.parametrosRdep,
    },
    {
        title: 'tributacion.subopciones.cierre_sri',
        route: names.ROUTE_CIERRE_SRI,
        resource: RESOURCE_TRIBUTACION_PG,
        action: configuracion.cierreSRI,
    },
    {
        title: 'tributacion.subopciones.matriz_tipo_contribuyente',
        route: names.ROUTE_MATRIZ_TIPO_CONTRIBUYENTE,
        resource: RESOURCE_TRIBUTACION_PG,
        action: configuracion.matrizTipoContribuyente,
    },
] as MenuConfig[]
